import { isWeb } from '@/utils/navigation';
import { LayoutSize, useLayoutContext } from '@/contexts/layout-context';

/**
 * Whether the screen should render the mobile bottom-nav layout
 * (single column, no sidebar, back button in the sub-bar).
 *
 * @returns True on native at the small layout size; false on web or any
 *    larger layout.
 *
 * @example
 * ```typescript
 * const isMobileBottomNavLayout = useIsMobileBottomNavLayout();
 *
 * {isMobileBottomNavLayout ? null : <View style={styles.sidebarColumn} />}
 * ```
 */
export const useIsMobileBottomNavLayout = (): boolean => {
  const { layoutSize } = useLayoutContext();
  return !isWeb && layoutSize === LayoutSize.SMALL;
};
